import { useTranslation } from 'react-i18next'
import { Check, Filter } from 'lucide-react'

import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { useNotificationDrawerActions } from '@/features/notification/hooks/hooks'
import { NotificationFilterType } from '@/features/notification/types'

const FILTER_OPTIONS: NotificationFilterType[] = [
  NotificationFilterType.All,
  NotificationFilterType.Assignments,
  NotificationFilterType.Comments,
  NotificationFilterType.Deadlines,
]

export const FilterDropdown = () => {
  const { t } = useTranslation()
  const { filterType, setFilterType } = useNotificationDrawerActions()

  const handleFilterSelect = (filter: NotificationFilterType) => {
    setFilterType(filter)
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="text"
          className="p-1 min-w-0"
          aria-label={t('notifications.actions.filter')}
          title={t('notifications.actions.filter')}
        >
          <Filter
            className="h-5 w-5"
            color="var(--Colors-Foreground-fg-quaternary-400)"
          />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" sideOffset={4}>
        {FILTER_OPTIONS.map((option) => (
          <DropdownMenuItem
            key={option}
            onClick={() => handleFilterSelect(option)}
            className="flex items-center justify-between"
          >
            <span>{t(`notifications.filter.${option}`)}</span>
            {filterType === option && <Check className="h-4 w-4 ml-2" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
